import { render } from "./ReportTrend.vue?vue&type=template&id=045d59a8&scoped=true"
import script from "./ReportTrend.vue?vue&type=script&lang=js"
export * from "./ReportTrend.vue?vue&type=script&lang=js"

import "./ReportTrend.vue?vue&type=style&index=0&id=045d59a8&scoped=true&lang=css"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045d59a8"]])

export default __exports__